import { Component, Input, OnInit } from '@angular/core';
import { ImageGallery1Component } from "../image-gallery1/image-gallery1.component";
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { ICartItem, IRoomUpgradeItem, IShopCart } from 'core-lib';
import { LanguageService } from 'core-lib';
import { AvailabilityService } from 'core-lib';
import { DisplayPricePipe } from '../../pipes/displayPrice';

@Component({
    selector: 'app-profile-room-upgrade',
    imports: [ImageGallery1Component, ButtonModule, TranslateModule, DisplayPricePipe],
    templateUrl: './profile-room-upgrade.component.html',
    styleUrl: './profile-room-upgrade.component.scss'
})
export class ProfileRoomUpgradeComponent implements OnInit {
  @Input() upgradeItem:IRoomUpgradeItem;
  @Input() shopCart:IShopCart;
  upgradeRoomCode:string;
  upgradeRoomName:string;
  salesPitch:string;
  upgradePriceDifference:number;
  language:string;

  constructor(private languageService:LanguageService) {}

  ngOnInit() {
    this.language = this.languageService.getCurrentLanguage();
    this.upgradeRoomCode = this.upgradeItem.config.to[0];
    this.upgradeRoomName = this.upgradeItem.roomrate.roomrates[0].room.pim.name;
    this.salesPitch = this.upgradeItem.config.salesPitch[this.language];
    
    let upgPrice = this.upgradeItem.roomrate.roomrates[0].totalPriceForStayWithTaxes;

    

    let currentPrice = this.shopCart.getFirstCartItem().item.totalPriceForStayWithTaxes
    this.upgradePriceDifference = upgPrice - currentPrice;

    //tää  oon vaan demoa varten kun antaa nollahintasen upgraden. saa poistaa
    if (this.upgradePriceDifference < 1 && (document.location.href.includes('localhost') || document.location.href.includes('cloud.hotellinx.com/sampo'))) {
      this.upgradePriceDifference = 10;
    }
  }

  upgrade() {
    alert('This will upgrade the room, but not yet ready.');
  }
}
